import { mapAtom } from '../../../atoms/map/map'
import { findLayer } from '../../utils/findLayer'

export function removeLocationPinFeature(pinId: uui.domain.ui.map.LocationPinId) {
  const map = mapAtom.map
  const layer = findLayer(map, 'pin')
  const feature = layer.getSource()?.getFeatureById(pinId)

  if (feature) {
    layer.getSource()?.removeFeature(feature)
  }
}
